import moment from 'moment'

export default function (date, format) {
  return moment(String(date)).format(format)
}
